module.exports = __webpack_public_path__ + "school/img/chuantongJc.6675f8fe.jpg";